export const Show = ({ condition, children }) => (condition ? children : null)
